namespace TabAurous.OMS {
    export namespace ProductSequenceService {
        export const baseUrl = 'OMS/ProductSequence';

        export declare function Create(request: Serenity.SaveRequest<ProductSequenceRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ProductSequenceRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ProductSequenceRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ProductSequenceRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetProductSequece(request: QCRequest, onSuccess?: (response: Serenity.ListResponse<ProductSequenceRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/ProductSequence/Create",
            Update = "OMS/ProductSequence/Update",
            Delete = "OMS/ProductSequence/Delete",
            Retrieve = "OMS/ProductSequence/Retrieve",
            List = "OMS/ProductSequence/List",
            GetProductSequece = "OMS/ProductSequence/GetProductSequece"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetProductSequece'
        ].forEach(x => {
            (<any>ProductSequenceService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
